import { useState, useEffect } from "react";
import NaviBar from "../NaviBar/NaviBar";
import SearchBar from "../NaviBar/SearchBar";
import Cookies from "js-cookie";
import noimg from "../../Icons/noimg.jpg";
import BottomCard from "../ShoppingCart/BottomCart";
import ProductCard from "../homeProduct/ProductCard";
import BrandCard2 from "../homeProduct/BrandCard2";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

function CategoryPage(props) {
  const { t } = useTranslation();
  const {
    cart,
    add,
    decreStock,
    changeProdPrice,
    alterquantity,
    itemCounter,
    langs,
    remove,
    setShowCart,
    showCart,
    setlangs,
    changePrice,
    promoRef,
  } = props;

  const { id, catename, brandOrCate } = useParams();

  const currentCate = JSON.parse(localStorage.getItem("currentCate"))
    ? JSON.parse(localStorage.getItem("currentCate"))
    : null;

  let Fname = "Products";
  if (currentCate?.name) {
    Fname =
      currentCate.name[langs] && currentCate.name[langs] !== ""
        ? currentCate.name[langs]
        : currentCate.name?.en;
  }

  const imageOnError = (ev) => {
    ev.target.src = noimg;
  };

  useEffect(() => {
    const mycoockie = Cookies.get("i18next");
    if (mycoockie === "fr") {
      setMainL("fr-CA");
    } else if (mycoockie === "es") {
      setMainL("es-US");
    }
  }, []);

  const [mainL, setMainL] = useState("en-US");
  const [showp, setShowp] = useState(false);

  let imageUrl = "";

  const machine = JSON.parse(localStorage.getItem("machine"));
  const allProductImage = machine.themeColor?.allProduct
    ? `${process.env.REACT_APP_SERVER_API}/pictures/${machine.themeColor?.allProduct}/${machine.belongTo}`
    : noimg;

  // const allProductImage = machine.themeColor?.allProduct
  // ? `${process.env.REACT_APP_SERVER_API}/pictures/${machine.themeColor?.allProduct}/${machine.belongTo}`
  // : noimg;

  let symbol = machine?.currency?.symbol;
  symbol = symbol ? symbol : "$";
  let result = JSON.parse(localStorage.getItem("products"));

  let brands = JSON.parse(localStorage.getItem("brand"))
    ? JSON.parse(localStorage.getItem("brand"))
    : [];

  if (catename !== "all" && catename !== "allBrand") {
    console.log("catename", catename);
    if (brandOrCate === "brand") {
      // imageUrl = `${process.env.REACT_APP_SERVER_API}/pictures/${currentCate.picture}/${currentCate.referTo}`;
      imageUrl = `${process.env.REACT_APP_SERVER_API}/pictures/${currentCate.picture}/${currentCate.referTo}`;
      result = result.filter((product) => product.brand?._id === id);
    } else if (brandOrCate === "cate") {
      console.log("catename11111", id);
      // imageUrl = `${process.env.REACT_APP_SERVER_API}/pictures/${currentCate.categoryPicture}/${currentCate.referTo}`;
      imageUrl = `${process.env.REACT_APP_SERVER_API}/pictures/${currentCate.categoryPicture}/${currentCate.referTo}`;
      result = result.filter((product) => product.category.includes(id));
    }
  } else {
    imageUrl = allProductImage;
  }

  // Define a common sorting function
  function sortByName(arr, langs) {
    return arr?.sort((a, b) => {
      const nameA = a.name[langs]
        ? a.name[langs].toUpperCase()
        : a.name["en"].toUpperCase();
      const nameB = b.name[langs]
        ? b.name[langs].toUpperCase()
        : b.name["en"].toUpperCase();
      if (nameA < nameB) {
        return -1;
      }
      if (nameA > nameB) {
        return 1;
      }
      return 0;
    });
  }

  if (catename === "allBrand") {
    if (machine.themeColor?.sp_column === "1") {
    } else {
      brands = sortByName(brands, langs);
    }
  } else {
    if (machine.themeColor?.sp_column === "1") {
    } else {
      result = sortByName(result, langs);
    }
  }

  const products =
    catename === "allBrand"
      ? brands.map((brand) => {
          // const url = `${process.env.REACT_APP_SERVER_API}/pictures/${brand.picture}/${brand.referTo}`;
          const url = `${process.env.REACT_APP_SERVER_API}/pictures/${brand.picture}/${brand.referTo}`;
          return (
            <BrandCard2
              key={brand._id}
              langs={langs}
              prod={brand}
              image={url}
            />
          );
        })
      : result.map((prod) => {
          // const url = `${process.env.REACT_APP_SERVER_API}/pictures/${prod.productPictures[0]}/${prod.referTo}`;
          const url = `${process.env.REACT_APP_SERVER_API}/pictures/${prod.productPictures[0]}/${prod.referTo}`;
          return (
            <ProductCard
              twoLine={true}
              langs={props.langs}
              mainL={mainL}
              symbol={symbol}
              setShowp={setShowp}
              cart={props.cart}
              alterquantity={props.alterquantity}
              add={props.add}
              key={prod._id}
              remove={remove}
              decreStock={props.decreStock}
              price={prod.price}
              id={prod._id}
              prod={prod}
              products={props.products}
              i={prod.idx}
              name={prod.name}
              buyX={prod.buyX}
              percentage={prod.percentage}
              discountedPrice={prod.discountedPrice}
              amount={prod.discount}
              image={url}
            />
          );
        });

  return (
    <div className="main-container">
      <div className="Navi"></div>
      <NaviBar setShowCart={setShowCart} setlangs={setlangs} cart={cart} />
      <SearchBar langs={langs} />
      {machine?.themeColor?.hide_category_banner !== "true" && (
        <img
          className="cate-banner-img"
          src={imageUrl}
          onError={imageOnError}
          alt=""
        ></img>
      )}

      <div className="cate-page-container">
        <div className="homeProductText" style={{ marginTop: "44px" }}>
          {catename === "all"
            ? t(`All Products`)
            : catename === "allBrand"
            ? t("All Brands")
            : Fname}
        </div>
        {currentCate?.limit && catename !== "all" && catename !== "all" ? (
          <div className="homeProductText" style={{ fontSize: "40px" }}>
            {`Limit: ${currentCate?.limit}`}
          </div>
        ) : null}
        <div className="cate-products-container">{products}</div>
      </div>
      <BottomCard
        promoRef={promoRef}
        changePrice={changePrice}
        cart={cart}
        setShowCart={setShowCart}
        showCart={showCart}
        prods={result}
        langs={langs}
        add={add}
        decreStock={decreStock}
        alterquantity={alterquantity}
        remove={remove}
      />
      {showCart && <div></div>}
    </div>
  );
}
export default CategoryPage;
